import React, { Component } from 'react';
import { SubMenuLink } from "../../SubMenuLink";

export default class MailingLists extends Component {

  render() {
    return <SubMenuLink pathname="/mailing-lists" title="mailing lists" icon="MAILING_LIST_LIGHT" />;
  }
};
